export const getAll = (auth) => {
  const url = `/locations`;
  return auth.fetch(url, { method: 'GET' });
}

export const save = (auth, location) => {
  return auth.fetch(`/locations`, { method: 'POST', body: JSON.stringify(location) });
}

export const deleteLocation = (auth, locationId) => {
  return auth.fetch(`/locations/${locationId}`, { method: 'DELETE' });
}

export default getAll;



// WEBPACK FOOTER //
// ./src/services/LocationService.js